import * as __au2ViewDef from './menu-entry.html';
import { bindable, customElement, EventAggregator } from 'aurelia';
import { DialogHelper } from 'resources/dialog_helper';
import { GlobalSelectedObject } from 'resources/global_selected_object';
import { GlobalStateObject } from 'resources/global_state_object';
import { PersistencyHandler } from 'resources/persistency_handler';

@customElement({ ...__au2ViewDef, name: 'menu-entry' })
export class MenuEntry {


   marginTop = '0';
   marginBottom = '0';
   marginLeft = '0';
   marginRight = '0';
   anchorCorner = 'BOTTOM_LEFT';
   anchorCorner2 = 'BOTTOM_LEFT';
   anchorCorner3 = 'BOTTOM_LEFT';
   anchorCorner4 = 'BOTTOM_LEFT';
   anchorCorner5 = 'BOTTOM_LEFT';
   private dialog = null;

   lastSelection: number;

   @bindable menuEntry: object = {};
   @bindable dialogSaveAs = null;
   @bindable dialogImportModel = null;

   constructor(
      private dialogHelper: DialogHelper,
      private persistencyHandler: PersistencyHandler,
      private globalStateObject: GlobalStateObject,
      private globalSelectedObject: GlobalSelectedObject,
      private eventAggregator: EventAggregator
   ) {
   }


   onMenuSelect(event: { index: number; item: string }) {
      this.lastSelection = event.index;
   }

   menuButtonClicked(item) {
      item.open = !item.open;
      this.menuEntry["open"] = item.open;
   }

   //logic to do the right thing for each menu entry
   async onItemClick(item) {

      // generic entries...----------------------------------------------------
      if (item.dialogName && item.eventPropagationName) {
         //call this with the item.eventPropagationName to open the dialog
         this.dialogHelper.openDialog(this[item.dialogName], item.eventPropagationName, {});
      }
      else if (item.dialogName) {
         //call this with the item.eventPropagationName to open the dialog
         this.dialogHelper.openDialog(this[item.dialogName], "", {});
      }

      // specific entries...----------------------------------------------------
      if (item.label === "Export Model as .json") {
         this.persistencyHandler.saveToTextfile();
      }

      if (item.label === "Export Open Models") {
         await this.persistencyHandler.saveAllOpenModelInstancesToTextfile();
      }

      if (item.label === "Enter Simulation Mode") {
         this.globalSelectedObject.removeObject();
         
         this.globalStateObject.setState(4);

         //remove attribute gui
         this.eventAggregator.publish('removeAttributeGui', { remove: true });
      }

      if (item.label === "Exit Simulation Mode") {
         this.globalSelectedObject.removeObject();
         this.globalStateObject.setState(1);
      }
   }
}
    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = MenuEntry;

    // @ts-ignore
    const proto = MenuEntry.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }